import axios from "axios";
import { baseUrl, portal } from "../App";
import { EVENT_ID } from "../assets/constant";
import { transformQuizardWinnerLeaderboardDataArray, transformWinnerlistDataArray } from "./transformDataFormat";

export const fetchLeaderboardByLeaderboarName = async (leaderboardName) => {
  if(!leaderboardName) return [];
  // for daily leaderboard
  if(leaderboardName === 'leaderboard_daily'){
    const res = await axios.get(`${baseUrl}/api/leaderboard/?portal=${portal}&event_id=${EVENT_ID.DAILY_EVENT}`);
    return res.data;
  }else if(leaderboardName === 'leaderboard_weekly'){
    const res = await axios.get(`${baseUrl}/api/leaderboard/?portal=${portal}&event_id=${EVENT_ID.WEEKLY_EVENT}`);
    return res.data;
  }else if(leaderboardName === 'leaderboard_tournament'){
    const res = await axios.get(`${baseUrl}/api/leaderboard/?portal=${portal}&event_id=${EVENT_ID.TOURNAMENT_EVENT}`);
    return res.data;
  }else if(leaderboardName === 'leaderboard_bcs'){
    const res = await axios.get(`${baseUrl}/api/leaderboard/?portal=${portal}&event_id=${EVENT_ID.BCS_EVENT}`);
    return res.data;
  }
  // for last 7 days winner leaderboard
  else if(leaderboardName === 'winner_daily'){
    const res = await axios.get(`${baseUrl}/money/weeklyWinner/?event_id=${EVENT_ID.DAILY_EVENT}`);
    return transformWinnerlistDataArray(res.data,10);
  }
  else if(leaderboardName === 'winner_weekly'){
    const res = await axios.get(`${baseUrl}/money/weeklyWinner/?event_id=${EVENT_ID.WEEKLY_EVENT}`);
    return transformWinnerlistDataArray(res.data,10);
  }
  else if(leaderboardName === 'winner_tournament'){
    const res = await axios.get(`${baseUrl}/api/NewyearTotalWinnerList/`);
    return res.data;
  }
  else if(leaderboardName === 'winner_bcs'){
    const res = await axios.get(`${baseUrl}/money/weeklyWinner/?event_id=${EVENT_ID.BCS_EVENT}`);
    return transformWinnerlistDataArray(res.data,10);
  }

  // for yesterday winner leaderboard
  // http://cms.quizard.live/money/tWinnerApiFrontendYesterday/?event_id=75
  // http://cms.quizard.live/money/tWinnerApiFrontendYesterday/?quizid=34&numberOfWinner=15 
  else if(leaderboardName === 'winner_y_daily'){
    // https://cms.quizard.live/34
    const res = await axios.get(`${baseUrl}/money/tWinnerApiFrontendYesterday/?event_id=${EVENT_ID.DAILY_EVENT}`);
    return transformQuizardWinnerLeaderboardDataArray(res.data,50);
  }
  else if(leaderboardName === 'winner_y_weekly'){
    const res = await axios.get(`${baseUrl}/money/tWinnerApiFrontendYesterday/?event_id=${EVENT_ID.WEEKLY_EVENT}`);
    return transformQuizardWinnerLeaderboardDataArray(res.data,40);
  }
  else if(leaderboardName === 'winner_y_tournament'){
    const res = await axios.get(`${baseUrl}/money/tWinnerApiFrontendYesterday/?event_id=${EVENT_ID.TOURNAMENT_EVENT}`);
    return transformQuizardWinnerLeaderboardDataArray(res.data,20);
  }
  else if(leaderboardName === 'winner_y_bcs'){
    const res = await axios.get(`${baseUrl}/money/tWinnerApiFrontendYesterday/?event_id=${EVENT_ID.BCS_EVENT}`);
    return transformQuizardWinnerLeaderboardDataArray(res.data,30);
  }
  else{
    return [];
  }
}